import axios from 'axios';
import {getUserApi, httpCookieRefreshTokenApi, refreshTokenApi} from '../api/profileApi';
import {mainUrl} from '../api/Urls';
import {useContext} from 'react';
import {UserContext} from '../utils/UserContext';
import {firebaseLogout, httpCookieLogoutApi} from '../api/authApi';
import {useAtom} from 'jotai';
import {notificationsAtom, unreadNotificationsAtom} from '../utils/atoms';

/**
 * Refreshes the user data with token refresh handling
 * @param {Function} setCurrentUser - Function to update user state
 * @returns {Promise<Object|null>} - Returns user data or null if failed
 */
export const refreshUserDataComplete = async (setCurrentUser) => {
	try {
		// First attempt with current access token
		const response = await getUserApi(localStorage.getItem('accessToken'));
		const userData = response.data;

		if (setCurrentUser) {
			setCurrentUser(userData);
		}

		console.log('Successfully fetched user on first try');
		return userData;
	} catch (error) {
		console.log(error);
		console.log('Could not fetch the user, trying to refresh token...');

		try {
			// Try refreshing the token
			// const refreshResponse = await refreshTokenApi(localStorage.getItem('token'));
			const refreshResponse = await httpCookieRefreshTokenApi();

			alert('got here');
			localStorage.setItem('accessToken', refreshResponse.data.access);

			// Try again with new token
			try {
				const userResponse = await getUserApi(localStorage.getItem('accessToken'));
				const userData = userResponse.data;

				if (setCurrentUser) {
					setCurrentUser(userData);
				}

				console.log('Successfully fetched user after token refresh');
				return userData;
			} catch (secondError) {
				console.log(secondError);
				console.log('Could not fetch user even after token refresh');
				localStorage.removeItem('accessToken');
				localStorage.removeItem('token');
				return null;
			}
		} catch (refreshError) {
			console.log(refreshError);
			console.log('Refreshing token failed, logging out the user...');
			localStorage.removeItem('accessToken');
			localStorage.removeItem('token');
			window.location.reload();
			return null;
		}
	}
};

/**
 * Custom hook for handling user logout functionality
 * @returns {Function} logout function that can be called to log out the user
 */
export const useLogout = () => {
	const [, setCurrentUser] = useContext(UserContext);
	const [, setNotifications] = useAtom(notificationsAtom);
	const [, setUnreadNotifications] = useAtom(unreadNotificationsAtom);

	const logout = async () => {
		// Clear local storage tokens
		localStorage.removeItem('accessToken');
		localStorage.removeItem('token');

		// Reset user context and notifications
		setCurrentUser('');
		setUnreadNotifications(0);
		setNotifications([]);

		// Logout from Firebase and clear HTTP cookies
		firebaseLogout();
		await httpCookieLogoutApi();
	};

	return logout;
};

export const getCsrfTokenApi = async () => {
	try {
		const response = await axios.get(mainUrl + '/auth/get-csrf-token/', {withCredentials: true});
		return response.data.csrfToken;
	} catch (error) {
		console.log(error);
	}
};
